import Reveal from "./Reveal";
import FaqAccordion from "./FaqAccordion";
import useI18n from "@/i18n";

/*
 * Les questions/réponses viennent des dictionnaires i18n. La version
 * française est reprise à l'identique dans le JSON-LD FAQPage de
 * public/index.html (schema.org) : toute modification française doit y être
 * répercutée mot pour mot.
 */
export default function FAQ() {
    const { t } = useI18n();

    return (
        <section id="faq" className="grad-up scroll-mt-24 py-16 md:py-24" data-testid="faq-section">
            <div className="mx-auto max-w-[840px] px-5">
                <Reveal>
                    <p className="eyebrow">{t.faq.eyebrow}</p>
                    <h2 className="text-3xl text-terrat md:text-4xl">{t.faq.h2}</h2>
                    <hr className="rule-gold mt-4 w-16" />
                    <p className="mt-4 max-w-[52ch] text-lg text-ink2">{t.faq.lead}</p>
                </Reveal>
                <div className="mt-10">
                    <FaqAccordion items={t.faq.items} />
                </div>
            </div>
        </section>
    );
}
